"use strict";

exports.registerServiceWorker = function () {
  return true;
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-offline/gatsby-browser.js
// module id = ./node_modules/gatsby-plugin-offline/gatsby-browser.js
// module chunks = 15178676390636814000